import React from "react";
import styles from "./ExpertsSection.module.scss";
import expert1 from "../../../assets/images/expert1.png";
import expert2 from "../../../assets/images/expert2.png";
import expert3 from "../../../assets/images/expert3.png";

const ExpertsSection = () => {
  return (
    <div className={styles.expertsSectionContainer}>
      <h1 className={styles.mainTitle}>Experts</h1>

      <div className={styles.expertList}>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={expert1} alt="The Title Of The Interview" />
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Interview">
              The Title Of The Interview
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={expert2} alt="The Title Of The Article" />
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Article">
              The Title Of The Article
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={expert3} alt="The Title Of The Work" />
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Work">
              The Title Of The Work
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
          </div>
        </div>
      </div>

      <div className={styles.viewAllCentered}>View All</div>
    </div>
  );
};

export default ExpertsSection;
